import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Skip guard if we're in the middle of authentication flow
    const isAuthFlow = globalThis.location.href.includes('code=') || globalThis.location.href.includes('error=');
    if (isAuthFlow) {
      return true;
    }
    
    // Check if user is authenticated by verifying UserInfo and token exist
    const userInfo = sessionStorage.getItem('UserInfo');
    const idToken = sessionStorage.getItem('id_token');
    
    if (userInfo && idToken) {
      // Check if token is expired
      if (this.isTokenExpired(idToken)) {
        this.clearSessionAndRedirect();
        return false;
      }
      
      const roles = this.getUserRoles();
      if (!roles || roles.length === 0) {
        this.clearSessionAndRedirect();
        return false;
      }
    
      return true;
    }

    this.clearSessionAndRedirect();
    return false;
  }

  private getUserRoles(): string[] {
    try {
      const idToken = sessionStorage.getItem('CERT_IDTOKEN');
      if (!idToken) {
        return [];
      }

      const decodedToken = JSON.parse(idToken);
      return decodedToken.roles || [];
    } catch (error) {
      console.trace('Failed to parse CERT_IDTOKEN:', error);
      return [];
    }
  }

  private isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (!payload.exp) {
        return true;
      }
      const expirationTime = payload.exp * 1000;
      const currentTime = Date.now();
      return currentTime >= expirationTime;
    } catch (error) {
       console.trace('Unexpected error occurred:', error);
      return true;
    }
  }

  private clearSessionAndRedirect(): void {
    if (sessionStorage.getItem('loggingOut')) {
      return;
    }
    
    sessionStorage.setItem('loggingOut', 'true');
    
    // Clear session storage except for PKCE values
    const codeVerifier = sessionStorage.getItem('code_verifier');
    const projectReturnUrl = sessionStorage.getItem('projectReturnUrl');
    sessionStorage.clear();
    if (codeVerifier) {
      sessionStorage.setItem('code_verifier', codeVerifier);
    }
    if (projectReturnUrl) {
      sessionStorage.setItem('projectReturnUrl', projectReturnUrl);
    }
    sessionStorage.setItem('loggingOut', 'true');
    
    this.router.navigate(['/']);
  }
}